/** @jsxImportSource @emotion/react */
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { SplashPage } from '@app/components/ui/SplashPage/SplashPage'
import { SplashBanner } from '@app/components/ui/SplashPage/SplashPageBanner'
import { Box, Button, css, Typography } from '@mui/material'
import {
  propertySearchContainer,
  propertySearchTitle,
} from '@app/components/Property/components/PropertyLandingPage.style'
import { useNavigate } from 'react-router-dom'
import { appLink } from '@app/config/appLink'

const prioritisationBannerImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_prioritisation_hero.svg`
const prioritisationLogoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_prioritisation_logo.svg`

export const PrioritisationLandingPage = () => {
  const navigate = useNavigate()

  return (
    <SplashPage>
      <SplashPage.Hero>
        <SplashBanner testId="property-splash-page-banner">
          <SplashBanner.Wrapper>
            <SplashBanner.LeftColumn>
              <SplashBanner.Logo
                src={prioritisationLogoImg}
                alt="Prioritisation - Resilience Explorer"
              />
              <SplashBanner.Headline>
                Prioritise adaptation areas based on values and key climate scenarios.
              </SplashBanner.Headline>
            </SplashBanner.LeftColumn>
            <SplashBanner.RightColumn>
              <SplashBanner.Image
                src={prioritisationBannerImg}
                alt="Prioritisation - Overview Image"
              />
            </SplashBanner.RightColumn>
          </SplashBanner.Wrapper>
        </SplashBanner>
      </SplashPage.Hero>
      <SplashPage.Content>
        <Box css={propertySearchContainer}>
          <Typography css={propertySearchTitle} variant="h4" component="h4">
            Prioritise your areas
          </Typography>
          <Box css={prioritisationButtonWrapper}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`${appLink.risk.path}/prioritisation/start?wizard=true`)}
            >
              Get started
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate(`${appLink.risk.path}/prioritisation/start`)}
            >
              Use default
            </Button>
          </Box>
        </Box>
      </SplashPage.Content>
    </SplashPage>
  )
}

export const prioritisationButtonWrapper = css`
  display: flex;
  gap: 16px;
  margin-top: 24px;
`
